import { X, Check } from "lucide-react";
import { Reveal, Eyebrow } from "./Reveal";

const BAD = ["Wrong location", "No buying intent", "Fake information", "Can't afford the service"];
const GOOD = ["Right location", "Needs your service", "Ready to talk", "Real contact information", "Potential customer"];

export const LeadQuality = () => (
  <section className="relative bg-[#FAFAFA] py-12 text-[#0A0A0F] sm:py-16">
    <div className="mx-auto max-w-7xl px-5 sm:px-8">
      <Reveal>
        <Eyebrow className="text-purple-600">Lead Quality</Eyebrow>
        <h2 className="mt-5 max-w-4xl font-display text-4xl font-extrabold leading-[0.95] tracking-tighter sm:text-5xl lg:text-6xl">
          More Leads Isn't Enough.{" "}
          <span className="text-purple-600">They Need To Be The Right Leads.</span>
        </h2>
        <p className="mt-6 max-w-2xl text-base leading-relaxed text-zinc-600 md:text-lg">
          Anyone can generate cheap form submissions. We care about whether
          those people can actually become customers.
        </p>
      </Reveal>

      <div className="mt-10 grid grid-cols-1 gap-4 lg:grid-cols-2">
        <Reveal>
          <div data-testid="bad-lead-card" className="h-full rounded-3xl border border-black/10 bg-white p-8 sm:p-10">
            <p className="font-display text-xl font-extrabold uppercase tracking-tight text-zinc-400">
              Bad Lead
            </p>
            <ul className="mt-6 space-y-4">
              {BAD.map((b) => (
                <li key={b} className="flex items-center gap-3.5">
                  <span className="flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-red-100">
                    <X className="h-4 w-4 text-red-500" strokeWidth={3} />
                  </span>
                  <span className="text-base font-medium text-zinc-500 line-through decoration-red-300">{b}</span>
                </li>
              ))}
            </ul>
          </div>
        </Reveal>
        <Reveal delay={0.1}>
          <div data-testid="good-lead-card" className="h-full rounded-3xl border-2 border-purple-600 bg-white p-8 shadow-xl shadow-purple-600/10 sm:p-10">
            <p className="font-display text-xl font-extrabold uppercase tracking-tight text-purple-600">
              Good Lead
            </p>
            <ul className="mt-6 space-y-4">
              {GOOD.map((g) => (
                <li key={g} className="flex items-center gap-3.5">
                  <span className="flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-purple-600">
                    <Check className="h-4 w-4 text-white" strokeWidth={3} />
                  </span>
                  <span className="font-display text-base font-extrabold tracking-tight">{g}</span>
                </li>
              ))}
            </ul>
          </div>
        </Reveal>
      </div>

      <Reveal delay={0.15}>
        <p className="mt-10 font-display text-3xl font-extrabold tracking-tighter sm:text-4xl lg:text-5xl">
          Good leads beat <span className="text-purple-600">big numbers.</span>
        </p>
      </Reveal>
    </div>
  </section>
);
